document.addEventListener("DOMContentLoaded", () => {
  // ===== FUNÇÕES HELPER (INTACTAS) =====
  const traducaoStatus = {
    deliveryStatus: {
      null: "Aguardando envio",
      in_transit: "Em trânsito",
      delivered: "Entregue",
      cancelled: "Cancelado",
      fulfilled: "Enviado",
      DELIVERED: "Entregue",
      IN_TRANSIT: "Em trânsito",
      SHIPPED: "Despachado",
      NEW: "Criado",
      READY_FOR_SHIPPING: "Pronto para envio",
      TO_BE_DELIVERED: "Saiu para entrega",
      to_be_delivered: "Saiu para entrega",
    },
    paymentStatus: {
      paid: "Pago",
      pending: "Pendente",
      refunded: "Reembolsado",
      failed: "Falhou",
    },
  };

  function calcularProgresso(statusEntrega) {
    switch (statusEntrega) {
      case null:
      case "pending":
      case "NEW":
        return 33; // Confirmado
      case "in_transit":
      case "fulfilled":
      case "IN_TRANSIT":
      case "SHIPPED":
      case "READY_FOR_SHIPPING":
      case "TO_BE_DELIVERED":
      case "to_be_delivered":
        return 66; // Em Trânsito
      case "delivered":
      case "DELIVERED":
        return 100; // Entregue
      case "cancelled":
        return 0; // Cancelado
      default:
        return 33; // Padrão
    }
  }

  function corProgresso(statusEntrega) {
    switch (statusEntrega) {
      case "delivered":
      case "DELIVERED":
        return "linear-gradient(90deg, #4caf50, #2e7d32)"; // Verde
      case "cancelled":
        return "linear-gradient(90deg, #f44336, #c62828)"; // Vermelho
      case "in_transit":
      case "fulfilled":
      case "IN_TRANSIT":
      case "SHIPPED":
      case "READY_FOR_SHIPPING":
      case "TO_BE_DELIVERED":
      case "to_be_delivered":
        return "linear-gradient(90deg, #ff9800, #f57c00)"; // Laranja
      default:
        return "linear-gradient(90deg, #5223DE, #411baf)"; // Roxo (padrão do print)
    }
  }

  function normalizeAcompanharUrl(rawUrl, trackingNumbers = []) {
    if (!rawUrl || typeof rawUrl !== "string") {
      if (trackingNumbers.length > 0) {
        const n = String(trackingNumbers[0]).trim();
        return `https://elements.acompanharentrega.com.br/?tpDoc=4&doc=${encodeURIComponent(n)}`;
      }
      return null;
    }
    try {
      const u = new URL(rawUrl);
      if (u.hostname.includes("acompanharentrega.com.br")) {
        const qs = u.search;
        const enc = qs.match(/tpDoc=(\d+)%3D([\d-]+)/i);
        const plain = qs.match(/tpDoc=(\d+)=([\d-]+)/i);
        if (enc) {
          u.search = `?tpDoc=${enc[1]}&doc=${enc[2]}`;
        } else if (plain) {
          u.search = `?tpDoc=${plain[1]}&doc=${plain[2]}`;
        } else {
          const tpDoc = u.searchParams.get("tpDoc");
          const hasDoc = u.searchParams.has("doc") || u.searchParams.has("Doc");
          if (tpDoc && tpDoc.includes("=") && !hasDoc) {
            const [tipo, numero] = tpDoc.split("=");
            u.searchParams.set("tpDoc", tipo);
            u.searchParams.set("doc", numero);
          }
          if (!u.searchParams.get("doc") && trackingNumbers.length > 0) {
            u.searchParams.set("doc", String(trackingNumbers[0]).trim());
            if (!u.searchParams.get("tpDoc")) u.searchParams.set("tpDoc", "4");
          }
        }
      }
      return u.toString();
    } catch {
      if (trackingNumbers.length > 0) {
        const n = String(trackingNumbers[0]).trim();
        return `https://elements.acompanharentrega.com.br/?tpDoc=4&doc=${encodeURIComponent(n)}`;
      }
      return rawUrl;
    }
  }

  // ===== FUNÇÃO DE FETCH DA INTELIPOST (MODIFICADA) =====
  async function buscarRastreamentoIntelipost(idPedido) {
    try {
      const res = await fetch(`https://backend-painel-do-cliente.onrender.com/intelipost/${idPedido}`);
      if (!res.ok) throw new Error(`Resposta da Intelipost não foi OK: ${res.status}`);
      
      const json = await res.json();
      const data = json.content;

      if (json.status !== "OK") {
        throw new Error("Requisição inválida à Intelipost");
      }

      // 1. Atualiza Previsão de Entrega
      const dataISO = data.estimated_delivery_date_iso;
      const dataReal = dataISO ? new Date(dataISO) : null;
      const strongEntrega = document.querySelector("strong.deliveryForecast");
      if (strongEntrega && dataReal) {
        strongEntrega.innerText = dataReal.toLocaleDateString("pt-BR");
      }

      // 2. Traduz o status
      const statusTraduzido = traducaoStatus.deliveryStatus[data.shipment_order_volume_state] || "Aguardando envio";

      // 3. Atualiza o status principal no card "Entrega"
      const strongStatusEntrega = document.querySelector("strong.statusOrder");
      if (strongStatusEntrega) {
        strongStatusEntrega.innerText = statusTraduzido;
      }

      // 4. Atualiza o status em CADA item do pedido
      const allItemStatus = document.querySelectorAll(".order-item-detail__status");
      allItemStatus.forEach(statusEl => {
        statusEl.innerText = statusTraduzido;
      });

      // 5. Atualiza a Barra de Progresso
      const progressoAtual = calcularProgresso(data.shipment_order_volume_state);
      const corBarra = corProgresso(data.shipment_order_volume_state);
      const progressFill = document.querySelector(".progress-fill-compact");
      const progressLabels = document.querySelectorAll(".progress-labels-compact span");

      if (progressFill) {
        progressFill.style.width = `${progressoAtual}%`;
        progressFill.style.background = corBarra;
      }

      if (progressLabels.length > 0) {
          // progressoAtual é 33 (Confirmado), 66 (Em trânsito), ou 100 (Entregue)
          progressLabels.forEach((label, index) => {
            // index 0 = "Confirmado", index 1 = "Em trânsito", index 2 = "Entregue"
            const thresholds = [33, 66, 100]; // Os pontos de ativação
            
            // Se o progresso atual for MAIOR ou IGUAL ao limite do label, ativa
            if (progressoAtual >= thresholds[index]) {
              label.classList.add("active");
            } else {
              label.classList.remove("active");
            }
          });
      }

      // 6. Lógica do Comprovante (Removida, pois o botão não está no layout)
      
    } catch (error) {
      console.error("Erro ao buscar rastreamento:", error);
      // Informa o usuário sobre o erro de forma visual
      const strongStatusEntrega = document.querySelector("strong.statusOrder");
      if (strongStatusEntrega) strongStatusEntrega.innerText = "Erro ao carregar";
      const allItemStatus = document.querySelectorAll(".order-item-detail__status");
      allItemStatus.forEach(statusEl => { statusEl.innerText = "Erro ao carregar"; });
    }
  }

  // ===== FUNÇÃO DE FETCH DA NOTA FISCAL (INTACTA) =====
  async function gerarNotaFiscal(idDaNota) {
    try {
      const response = await fetch(`https://backend-painel-do-cliente.onrender.com/nfe/${idDaNota}`);
      if (!response.ok) throw new Error("Erro ao buscar nota fiscal");
      const dadosNota = await response.json();
      return dadosNota;
    } catch (error) {
      console.error("Erro em gerarNotaFiscal:", error);
      const btnNotaFiscal = document.querySelector("#emitirNotaFiscal");
      if (btnNotaFiscal) {
        btnNotaFiscal.classList.add("disabledLinkBtn");
        btnNotaFiscal.innerText = "NF Indisponível";
      }
    }
  }

  // ===== FUNÇÃO "RENDER" (AGORA É "ATTACH") =====
  // Esta função não cria mais HTML, apenas anexa os eventos e dados.
  function attachDynamicData(pedido, numeroPedido, idPedido) {

    // 1. Botões de Review (Lógica mantida, seletores atualizados)
    const items = document.querySelectorAll(".order-item-detail"); // Seletor novo
    items.forEach((item) => {
      const linkProduto = item.querySelector(".order-item-detail__title")?.getAttribute("href"); // Seletor novo
      if (!linkProduto) return;

      const btn = document.createElement("a");
      btn.href = `${linkProduto}#reviews`;
      btn.classList.add("reviewsBtn");
      btn.target = "_blank";
      btn.innerHTML = '<svg fill="#ffffff" width="17" height="17" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><path d="M1915.918 737.475c-10.955-33.543-42.014-56.131-77.364-56.131h-612.029l-189.063-582.1v-.112C1026.394 65.588 995.335 43 959.984 43c-35.237 0-66.41 22.588-77.365 56.245L693.443 681.344H81.415c-35.35 0-66.41 22.588-77.365 56.131-10.955 33.544.79 70.137 29.478 91.03l495.247 359.831-189.177 582.212c-10.955 33.657 1.13 70.25 29.817 90.918 14.23 10.278 30.946 15.487 47.66 15.487 16.716 0 33.432-5.21 47.775-15.6l495.134-359.718 495.021 359.718c28.574 20.781 67.087 20.781 95.662.113 28.687-20.668 40.658-57.261 29.703-91.03l-189.176-582.1 495.36-359.83c28.574-20.894 40.433-57.487 29.364-91.03" fill-rule="evenodd"></path></svg> <span class="textReviews">Verificar Avaliações</span>';
      btn.style = "display: inline-flex; align-items: center; justify-content: center; gap: 6px; background-color: #6734ff; color: white; padding: 8px 16px; border-radius: 5px; text-decoration: none; font-weight: 600; font-size: 14px; margin-top: 6px;";
      btn.addEventListener("mouseenter", () => { btn.style.backgroundColor = "#5223de"; });
      btn.addEventListener("mouseleave", () => { btn.style.backgroundColor = "#6734ff"; });

      const infoDiv = item.querySelector(".order-item-detail__info"); // Seletor novo
      if (infoDiv) infoDiv.appendChild(btn);
    });

    // 2. Botão Rastreio (Lógica mantida, seletor atualizado)
    fetch(`https://shopify-tracking.onrender.com/api/shopify-tracking/${numeroPedido}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Erro na API: ${response.status} ${response.statusText}`);
        return response.json();
      })
      .then((data) => {
        const trackingNumbers = Array.isArray(data.tracking_numbers) ? data.tracking_numbers : [];
        const trackingUrls = Array.isArray(data.tracking_urls) ? data.tracking_urls : [];
        let trackingUrl = trackingUrls.find(Boolean) || null;
        trackingUrl = normalizeAcompanharUrl(trackingUrl, trackingNumbers);

        const btnAvaliarEl = document.querySelector(".evaluateOrder"); // Seletor novo
        if (!btnAvaliarEl) return;

        if (trackingUrl) {
          btnAvaliarEl.classList.remove("disabledLinkBtn");
          btnAvaliarEl.href = trackingUrl;
          btnAvaliarEl.innerText = "Rastrear Pedido";
        } else {
          btnAvaliarEl.classList.add("disabledLinkBtn");
          btnAvaliarEl.removeAttribute("href");
          btnAvaliarEl.innerText = "Rastreio indisponível";
        }
      })
      .catch((error) => {
        console.error("❌ Erro na requisição de rastreio:", error);
        const btnAvaliarEl = document.querySelector(".evaluateOrder");
        if (btnAvaliarEl) {
          btnAvaliarEl.classList.add("disabledLinkBtn");
          btnAvaliarEl.removeAttribute("href");
          btnAvaliarEl.innerText = "Rastreio indisponível";
        }
      });

    // 3. Seta o estado inicial da barra de progresso (com dados do 1º fetch)
    const progressoAtual = calcularProgresso(pedido.status_entrega);
    const corBarra = corProgresso(pedido.status_entrega);
    const progressFill = document.querySelector(".progress-fill-compact");
    if (progressFill) {
      progressFill.style.width = `${progressoAtual}%`;
      progressFill.style.background = corBarra;
    }
    // 3.5. Seta o estado inicial dos LABELS
    const progressLabels = document.querySelectorAll(".progress-labels-compact span");
    if (progressLabels.length > 0) {
      progressLabels.forEach((label, index) => {
        const thresholds = [33, 66, 100]; // Pontos de ativação
        
        // Se o progresso atual for MAIOR ou IGUAL ao limite do label, ativa
        if (progressoAtual >= thresholds[index]) {
          label.classList.add("active");
        } else {
          label.classList.remove("active");
        }
      });
    }
    
    // 4. Botão Nota Fiscal (Lógica mantida, seletor atualizado)
    const btnNotaFiscalEl = document.querySelector("#emitirNotaFiscal"); // Seletor novo
    if (btnNotaFiscalEl) {
      btnNotaFiscalEl.addEventListener("click", async () => {
        try {
          const res = await fetch(`https://backend-painel-do-cliente.onrender.com/pedidos/vendas/${idPedido}`);
          if (!res.ok) throw new Error("Erro ao buscar pedido");
          const idNota = await res.json();
          const downloadOptions = await gerarNotaFiscal(idNota);
          if (downloadOptions.pdf) window.open(downloadOptions.pdf, "_blank");
          else if (downloadOptions.xml) window.open(downloadOptions.xml, "_blank");
          else if (downloadOptions.danfe) window.open(downloadOptions.danfe, "_blank");
          else alert("Sem opções de download disponíveis");
        } catch (e) {
          console.log("Erro ao procurar Pedido... ", e);
          btnNotaFiscalEl.innerText = "NF Indisponível";
          btnNotaFiscalEl.classList.add("disabledLinkBtn");
        }
      });
    }
  }

  // ===== PONTO DE ENTRADA (MODIFICADO) =====

  // 1. Seletor do número do pedido ATUALIZADO
  const orderNumberElement = document.querySelector(".order-page-header h1");
  let numeroPedido = null;
  let idPedido = null;

  // 2. Spinner (INTACTO)
  const spinner = document.createElement("div");
  spinner.id = "loadingSpinner";
  spinner.innerHTML = `
    <div style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(255,255,255,0.8); display: flex; align-items: center; justify-content: center; z-index: 10000;">
      <div style="width: 48px; height: 48px; border: 5px solid #ccc; border-top: 5px solid #6734ff; border-radius: 50%; animation: spin 1s linear infinite;"></div>
      <style>@keyframes spin {to {transform: rotate(360deg);}}</style>
    </div>
  `;
  document.body.appendChild(spinner);

  // 3. Extrator de número (INTACTO)
  if (orderNumberElement) {
    const pedido = orderNumberElement.innerText || orderNumberElement.textContent;
    numeroPedido = pedido.split(" ")[1].replace("#", "").trim();
  }
  if (!numeroPedido) {
    console.error("Número do pedido não encontrado na página.");
    spinner.remove();
    return;
  }

  const pedidoName = encodeURIComponent(`#${numeroPedido}`);
  fetch(`https://backend-painel-do-cliente.onrender.com/pedidos/${pedidoName}`)
    .then((res) => res.json())
    .then((pedido) => {
      if (pedido.erro) {
        console.error(pedido.erro);
        spinner.remove();
        return;
      }
      idPedido = pedido.id;
      
      attachDynamicData(pedido, numeroPedido, idPedido);
      
      buscarRastreamentoIntelipost(idPedido).catch(console.error);
      
      spinner.remove();
    })
    .catch((err) => {
      console.error(err);
      spinner.remove();
    });
});